<template>
  <div>
    <slot />
    <UNotifications />
  </div>
</template>
